import React from 'react'
import { useFetchAiAcceptanceRateAnalyticsQuery } from '../../../../../../../store/apis/analytics.api'
import AcceptanceAnalyticsByCategoryTable from '../components/AcceptanceAnalyticsByCategoryTable' 

const AiAcceptanceRateChart = ({ token, includeAutoApproved }) => {
    const { data: analytics, isFetching, error } = useFetchAiAcceptanceRateAnalyticsQuery({
        token,
        include_auto_approved: includeAutoApproved,
    })

    return (
        <AcceptanceAnalyticsByCategoryTable
            analytics={analytics}
            isFetching={isFetching}
            error={error}
            description='This table shows the percentage of manually reviewed items where the AI classification was changed across different confidence levels. Click on a question row to expand and see the breakdown by rubric. If no items have been reviewed for a confidence level, "N/A" is shown.'
        />
    )
}

export default AiAcceptanceRateChart